// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-zoom-container[data-v-0d4c18fa]{position:relative}*[data-v-0d4c18fa]{box-sizing:border-box}.img-zoom-lens[data-v-0d4c18fa]{position:absolute;border:1px solid #d4d4d4;width:40px;height:40px}.img-zoom-result[data-v-0d4c18fa]{border:0 solid #d4d4d4;margin-top:.5rem;width:300px;height:300px;position:absolute;top:-8px;z-index:100;right:-310px}", ""]);
// Exports
module.exports = exports;
